module.exports = __webpack_public_path__ + "9adb388c7e171d672ead18ec522536fa.gif";


/*****************
 ** WEBPACK FOOTER
 ** ./components/Message/images/zoom-pavillion.gif
 ** module id = 396
 ** module chunks = 0
 **/